<template>
  <div class="product-slide-one">
    <div class="top-view">
      <p class="title">
        <span class="stand">{{ $t('productServices.card2.text1') }}</span>
        <span >{{ $t('productServices.card2.text2') }}</span>
      </p>
      <p class="desc">{{ $t('productServices.card2.desc') }}</p>
      <img class="project-img" loading="lazy" v-if="locale == 'zh'" :src="`${$COS}/project_gc.png`" alt="">
      <img class="project-img" loading="lazy" v-if="locale == 'en'" :src="`${$COS}/en_project_gc.png`" alt="">
    </div>
    <div class="flow-view">
      <div class="flow-text">{{$t('productServices.tips')}}</div>
      <img class="progress-img" loading="lazy" :src="`${$COS}/img_progress.png`">
      <div class="progress-view">
        <div class="flow-item" v-for="item in productProgress2" :key="item">
          <p :class="`item-title ${locale}-item-title`">{{item.label}}</p>
          <p class="item-desc">{{item.tip}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from "vue-i18n";
const { locale } = useI18n();
import { productProgress2 }  from '@/utils/enumeration'


</script>


<style scoped lang="scss">
@import './product.scss';
</style>
